export default __webpack_public_path__ + "static/media/poppy_carousel_3.png.webp";